<div class="cm-popup">
	<div class="popup-wrap">
		<div class="popup">
			<div class="cm-popup-content">
				<div>
					<img *ngIf="data.type=='failed'" src="assets/images/error-icon.png" alt="error">
                    <img *ngIf="data.type=='success'" src="assets/images/success-icon.png" alt="success">
                    <p [innerHtml]="data.msg"></p>
				</div>
			</div>
			<div class="btn-section" >
				<button class="btn btn-red" [mat-dialog-close]="true" style="box-shadow:none;outline:none">OK</button>
			</div>
		</div>
	</div>
</div>